export const shopItems = [
    {
        number: '#001',
        price: '26Ξ',
        media: "https://bafybeici56w2drvw3vgy3um3ckpew7sl7rpzbmptcwjxxxmk4vgq2wkamq.ipfs.nftstorage.link"
    },
    {
        number: '#002',
        price: '26Ξ',
        media: 'https://bafkreibun23j7zif6ss32onkac5wsrk6p4yxhkleayyoeuwajvjxgbcjpa.ipfs.nftstorage.link'
    },
    {
        number: '#003',
        price: '26Ξ',
        media: 'https://bafkreid37aaxzay63vaowfyw34jdzrz6rnrcxbcaa2v6nmenne6flnv2ie.ipfs.nftstorage.link'
    },
    {
        number: '#004',
        price: '26Ξ',
        media: 'https://bafybeiddsm6cp5ukkhzubpw2f2p32loyhz6iwqpfpctghs43z7jnptaicu.ipfs.nftstorage.link'
    },
    {
        number: '#005',
        price: '26Ξ',
        media: 'https://bafybeibxixjsi5rurf7s354chb5z6nmtth7ia34extetvopkle4zhyxt6y.ipfs.nftstorage.link'
    },
    {
        number: '#006',
        price: '26Ξ',
        media: 'https://bafkreib3zfyhkwljsrdtcodx7i4sdzows3drea4d2eppqdwhknzf74jvzq.ipfs.nftstorage.link'
    },
    {
        number: '#007',
        price: '26Ξ',
        media: 'https://bafkreiayqzliwgcseghftshcflb3izsvddtqalo5mbpuyh3h2nijxho744.ipfs.nftstorage.link'
    },
    {
        number: '#008',
        price: '26Ξ',
        media: 'https://bafkreihezplgtt63aeow5phf3cf7x2onnivrbxu3vocixaggx5ynxq66o4.ipfs.nftstorage.link'
    },
    {
        number: '#009',
        price: '26Ξ',
        media: 'https://bafybeiddxsg34kngut5ndcrjs2ybjlqgkwp3kqbq7eum7j5dsjnyarbqqa.ipfs.nftstorage.link/'
    },
    {
        number: '#010',
        price: '26Ξ',
        media: 'https://bafybeiet5cmdcxtn77i2ssggtw67i6viogjffl2l27alsecgoed3ofw6f4.ipfs.nftstorage.link/'
    },
    {
        number: '#011',
        price: '26Ξ',
        media: 'https://bafybeibyjmjw7rmjfkif4c7fwzaxyxwzv3qg5hcyb3p76ocb7wmscr6co4.ipfs.nftstorage.link/'
    },
    {
        number: '#0012',
        price: '26Ξ',
        media: 'https://bafybeial4gjtdwhyj2c5roccquszf3yeqxtrvnscl44v4cqo52wsligjmm.ipfs.nftstorage.link/'
    },
    {
        number: '#013',
        price: '26Ξ',
        media: 'https://bafybeifpaucpsturt7hnqalrk746rfndduxjv2lbataewez344kdfgphzi.ipfs.nftstorage.link/'
    },
    {
        number: '#014',
        price: '26Ξ',
        media: 'https://bafybeicwb6kustccmi3h5wkh4m6dl4heolv7ribxk3lm3kq2gtvoe7u2ji.ipfs.nftstorage.link/'
    },
    {
        number: '#015',
        price: '26Ξ',
        media: 'https://bafybeid5z5qvctt3hiqxsfwb56yg72jilscco5kvl26rz3hy5rtnrhdweu.ipfs.nftstorage.link/'
    },
    {
        number: '#016',
        price: '26Ξ',
        media: 'https://bafybeidqxbje7zdqyhqfbyw7xrqzg2j3ha462gnlzu3ivmc6iwcupa3p4q.ipfs.nftstorage.link/'
    },
    {
        number: '#017',
        price: '26Ξ',
        media: 'https://bafybeih4zwc3c4gq4uztie4h5qfukwg2j2p2jjpehlnyiyswj6k2pyyovm.ipfs.nftstorage.link/'
    },
    {
        number: '#018',
        price: '26Ξ',
        media: 'https://bafybeigbuciifttwv3ck52vvd7tzdoft7n6dnxd7ggn7vzddu7qfgouune.ipfs.nftstorage.link/'
    },
    {
        number: '#019',
        price: '26Ξ',
        media: 'https://bafybeiafegjg6ecugqoivdogrqspvoxcvdkhqzwac4kqcfybqbsft3iuwy.ipfs.nftstorage.link/'
    },
    {
        number: '#020',
        price: '26Ξ',
        media: 'https://bafybeigtmsncs3smapkugogwitkcmmdtsdfpd4otloyfudyrpx6ezaxt3m.ipfs.nftstorage.link/'
    },
    {
        number: '#021',
        price: '26Ξ',
        media: 'https://bafybeiellqti2qbwn5rjvyxidhhincmu4rd2oe6tbo2zubqafzfgbbjclm.ipfs.nftstorage.link/'
    },
    
]